<template>

    <a class="jo-copy-btn jo-copy-image" v-clipboard:copy="text" v-clipboard:success="onCopy" >
      <svg t="1627371891742" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
           p-id="2021" width="15" height="15">
        <path
          d="M891.072 822.144V167.36a34.432 34.432 0 0 0-34.432-34.432H201.856C201.856 94.848 232.704 64 270.784 64h620.288C929.152 64 960 94.848 960 132.928v620.288c0 38.08-30.848 68.928-68.928 68.928z m-68.928-551.36v620.288c0 38.08-30.848 68.928-68.928 68.928H132.928A68.928 68.928 0 0 1 64 891.072V270.784c0-38.08 30.848-68.928 68.928-68.928h620.288c38.08 0 68.928 30.848 68.928 68.928z m-137.856 137.856H201.856a34.432 34.432 0 0 0 0 68.864h482.432a34.432 34.432 0 0 0 0-68.864z m0 206.72H201.856a34.432 34.432 0 0 0 0 68.864h482.432a34.432 34.432 0 0 0 0-68.864z"
          p-id="2022" :fill="ARTICLE.theme"></path>
      </svg>

    </a>
    <!--<img class="jo-copy-btn" v-clipboard:copy="text" v-clipboard:success="onCopy" :src="imgurl">-->
</template>

<script>
    export default {
      data() {
        return {
          imgurl: require('../../assets/img/copy.png')
        }
      },

      props:[
          'text'
      ],
      methods:{
          onCopy:function(){
            this.$message.closeAll();
              this.$message({
                  message:'引文信息已复制，您可以直接黏贴',
                  type:'success',
                  customClass:'quote-message-box'
              });
          }
      }
    }
</script>

<style lang="scss" scoped>
  .jo-copy-image{
    img{
      vertical-align: text-bottom;
      height: 14px;
      width: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/publish/clipboard.vue